<div id="employee_idcard" class="modal custom-modal fade" role="dialog" style="display: none;" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered modal-xl" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title">Request New ID Card</h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="closeModal()">
                    <span aria-hidden="true">×</span>
                </button>
            </div>
            <div class="modal-body">
                <form [formGroup]="idCardForm" (ngSubmit)="submitIdCard()">
                    <div class="row">
                        <div class="col-md-6">
                            <div class="form-group">
                                <label>Employee <span class="text-danger">*</span></label>
                                <input class="form-control" type="text" formControlName="username" readonly>
                            </div>
                        </div>
                        <div class="col-md-6">
                            <div class="form-group">
                                <label>Contact Number <span class="text-danger">*</span></label>
                                <input type="number" class="form-control" formControlName="number" placeholder="Contact Number">
                                <div *ngIf="submitted && idErrMsg.number.errors" class="form-error">
                                    <div *ngIf="idErrMsg.number.errors.required">Contact Number is required !</div>
                                 </div>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-6">
                            <div class="form-group">
                                <label>Upload Photo <span class="text-danger">*</span></label>
                                <input type="file" class="form-control" formControlName="file" (change)="onFileChange($event)" />
                                <span class="form-error">* only .jpg, .jpeg, .png, .tiff allowed</span>
                                <div *ngIf="submitted && idErrMsg.file.errors" class="form-error">
                                    <div *ngIf="idErrMsg.file.errors.required">Photo is required !</div>
                                 </div>
                            </div>
                        </div>
                        <div class="col-md-6">
                            <div class="form-group">
                                <label>Select Blood Group<span class="text-danger">*</span></label>
                                <select class="form-control" formControlName="blod_grp_id">
                                    <option value="">Select</option>
                                    <option *ngFor="let item of bpList" value={{item.value}}>{{item.label}}</option>
                                </select>
                                <div *ngIf="submitted && idErrMsg.blod_grp_id.errors" class="form-error">
                                    <div *ngIf="idErrMsg.blod_grp_id.errors.required">Please Choose an option !</div>
                                 </div>
                            </div>
                        </div>
                    </div>

                    <div class="text-center">
                        <button class="btn btn-primary btn-sm">Submit</button>
                    </div>
                </form>


                <!-- table -->

                <div class="row m-t-30">
                    <div class="col-md-12">
                        <div class="text-center m-b-10">
                           <b>ID Card History</b>
                        </div>
                        <!-- <div class="row" *ngIf="rm">
                            <div class="col-md-4"></div>
                            <div class="col-md-4"></div>
                            <div class="col-md-4">
                                <div class="form-group">
                                    <label>Search By Employee ID</label>
                                    <div class="row">
                                       <div class="col-10 padding-right-2">
                                          <div class="form-group">
                                             <input type="text" placeholder="Search User" [(ngModel)]="emp" class="form-control">
                                          </div>
                                       </div>
                                       <div class="col-2 col-pn">
                                          <button type="button" class="btn btn-warning btn-sm" (click)="searchEmp()">Search</button>
                                       </div>
                                    </div>
                                 </div>
                            </div>
                        </div> -->
                       <div class="table-responsive">
                          <table class="table">
                             <thead>
                                <tr class="bg-primary text-white">
                                    <th>Sr No.</th>
                                    <th>Employee</th>
                                    <th>Mobile</th>
                                    <th>Region</th>
                                    <th>Cost Center</th>
                                    <th>Requested Date</th>
                                    <th>RM Name</th>
                                    <th>Approve Date</th>
                                    <th>Image</th>
                                    <th>Resolved Date</th>
                                    <th>Resolved By</th>
                                    <th>Spoc Remark</th>
                                    <th>Status</th>
                                </tr>
                             </thead>
                             <tbody>
                                <tr *ngFor="let item of data; let i = index">
                                    <td>{{i+1}}</td>
                                    <td>{{item.EmpName}}</td>
                                    <td>{{item.mobile}}</td>
                                    <td>{{item.rgn_name}}</td>
                                    <td>{{item.cc_ext_id}} - {{item.cc_desc}}</td>
                                    <td>{{item.req_date}}</td>
                                    <td>{{item.RmName}}</td>
                                    <td>{{item.appr_date}}</td>
                                    <td>
                                       <a href={{item.documents}} *ngIf="item.documents" target="_blank">
                                          <button class="btn-primary">View</button>
                                       </a>
                                    </td>
                                    <td>{{item.complete_date}}</td>
                                    <td>{{item.CompltByEmpName}}</td>
                                    <td>{{item.spoc_remark}}</td>
                                    <td>{{item.req_status_desc}}</td>
                                </tr>
                             </tbody>
                          </table>
                       </div>
                    </div>
                 </div>

            </div>
        </div>
    </div>
</div>